// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customSelect:focus {\n  box-shadow: 0 0 3pt 2pt #719ece;\n}\n", ""]);
// Exports
module.exports = exports;
